import { useQuery } from '@tanstack/react-query'
import { fetchOrderStatus } from '../api/client'
import type { OrderStatus, OrderStatusResponse } from '../api/types'

export const TERMINAL_STATUSES: OrderStatus[] = [
  'paid',
  'accepted',
  'ready',
  'completed',
  'payment_failed',
  'cancelled',
  'expired',
]

export function isTerminalStatus(status: OrderStatus | undefined): boolean {
  return !!status && TERMINAL_STATUSES.includes(status)
}

export function computeRefetchInterval(
  status: OrderStatus | undefined,
  dataUpdatedAt: number,
  now: number,
): number | false {
  if (isTerminalStatus(status)) return false
  const elapsedMs = now - dataUpdatedAt
  return elapsedMs < 10_000 ? 1_000 : 5_000
}

export function useOrderStatus(orderId: string) {
  return useQuery<OrderStatusResponse, Error>({
    queryKey: ['order-status', orderId],
    queryFn: () => fetchOrderStatus(orderId),
    enabled: !!orderId,
    refetchInterval: (query) =>
      computeRefetchInterval(query.state.data?.status, query.state.dataUpdatedAt, Date.now()),
    retry: false,
  })
}
